import { Card } from '@/components/card'
import { PageHeader } from '@/components/page-header'
import { PageShell } from '@/components/page-shell'
import { ThemeToggle } from '@/components/theme-toggle'
import { PasskeyCard, PasswordCard } from '@/features/auth/passkey-card'
import { SessionCard } from '@/features/auth/session-card'
import { UserAdminCard } from '@/features/auth/user-admin-card'
import { AiUsagePanel } from '@/features/settings/ai-usage-panel'
import { AppSettingsCard } from '@/features/settings/app-settings-card'
import { BriefingSettingsCard } from '@/features/settings/briefing-settings-card'
import { HandoverSettingsCard } from '@/features/settings/handover-settings-card'
import { useTheme } from '@/features/theme/use-theme'

export function SettingsPage() {
  const { preference, resolved } = useTheme()

  return (
    <PageShell>
      <PageHeader
        title="Einstellungen"
        description="Anmeldung, Konten, Darstellung, die Regeln für Unterlagen, Abgleich und Übergabeprotokolle, und die KI-Nutzung."
      />

      <div className="flex flex-col gap-5">
        <PasskeyCard />
        <PasswordCard />
        <SessionCard />
        <UserAdminCard />
        <AppSettingsCard />
        <HandoverSettingsCard />
        <BriefingSettingsCard />
        <AiUsagePanel />

        <Card
          title="Darstellung"
          footer={
            preference === 'system'
              ? `Folgt der Systemeinstellung — aktuell ${resolved === 'dark' ? 'dunkel' : 'hell'}.`
              : 'Feste Auswahl — unabhängig von der Systemeinstellung.'
          }
        >
          <p className="text-muted mb-4 text-sm">
            Hell oder dunkel. „System“ übernimmt die Einstellung des Geräts und wechselt automatisch
            mit.
          </p>

          <ThemeToggle showLabels />

          <p className="text-faint mt-4 text-xs">
            Die Auswahl gilt nur für diesen Browser und wird lokal gespeichert — sie wird nicht an
            den Server übertragen.
          </p>
        </Card>

        <Card>
          <p className="text-muted text-sm">
            Zugangsdaten und Sicherheitsregeln — die onOffice-Schlüssel, die Verschlüsselung, die
            Sitzungsdauern, die Sperre gegen Schreibzugriffe — liegen bewusst nicht hier, sondern in
            der Konfiguration des Servers. Sie sind aus dem Browser nicht erreichbar und auch von
            hier aus nicht zu ändern.
          </p>
        </Card>
      </div>
    </PageShell>
  )
}
